import type { ComponentType } from "react";
import Svg, { Path } from "react-native-svg";
import type { CustomLevelIconName } from "./custom-level-icon-names";

export type { CustomLevelIconName } from "./custom-level-icon-names";
export { isCustomLevelIconName } from "./custom-level-icon-names";

export type CustomLevelIconProps = {
	size?: number;
	color?: string;
};

const ToeicBasicIcon = ({
	size = 24,
	color = "black",
}: CustomLevelIconProps) => (
	<Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
		<Path
			d="M5.4 19.6001C4.65 18.8501 4.0625 17.9835 3.6375 17.0001C3.2125 16.0168 3 15.0001 3 13.9501C3 12.9001 3.2 11.8626 3.6 10.8376C4 9.81262 4.65 8.85012 5.55 7.95012C6.13333 7.36679 6.85417 6.86679 7.7125 6.45012C8.57083 6.03345 9.5875 5.70429 10.7625 5.46262C11.9375 5.22095 13.2792 5.07512 14.7875 5.02512C16.2958 4.97512 17.9833 5.03345 19.85 5.20012C19.9833 6.96679 20.025 8.59179 19.975 10.0751C19.925 11.5585 19.7875 12.896 19.5625 14.0876C19.3375 15.2793 19.0208 16.321 18.6125 17.2126C18.2042 18.1043 17.7 18.8501 17.1 19.4501C16.2167 20.3335 15.2792 20.9793 14.2875 21.3876C13.2958 21.796 12.2833 22.0001 11.25 22.0001C10.1667 22.0001 9.10833 21.7876 8.075 21.3626C7.04167 20.9376 6.15 20.3501 5.4 19.6001ZM8.2 19.2001C8.68333 19.4835 9.17917 19.6876 9.6875 19.8126C10.1958 19.9376 10.7167 20.0001 11.25 20.0001C12.0167 20.0001 12.775 19.846 13.525 19.5376C14.275 19.2293 14.9917 18.7335 15.675 18.0501C15.975 17.7501 16.2792 17.3293 16.5875 16.7876C16.8958 16.246 17.1625 15.5376 17.3875 14.6626C17.6125 13.7876 17.7833 12.7293 17.9 11.4876C18.0167 10.246 18.0333 8.76679 17.95 7.05012C17.1333 7.01679 16.2125 7.00429 15.1875 7.01262C14.1625 7.02095 13.1417 7.10012 12.125 7.25012C11.1083 7.40012 10.1417 7.64179 9.225 7.97512C8.30833 8.30845 7.55833 8.76679 6.975 9.35012C6.225 10.1001 5.70833 10.8418 5.425 11.5751C5.14167 12.3085 5 13.0168 5 13.7001C5 14.6835 5.1875 15.546 5.5625 16.2876C5.9375 17.0293 6.26667 17.5501 6.55 17.8501C7.25 16.5168 8.175 15.2376 9.325 14.0126C10.475 12.7876 11.8167 11.7835 13.35 11.0001C12.15 12.0501 11.1042 13.2376 10.2125 14.5626C9.32083 15.8876 8.65 17.4335 8.2 19.2001Z"
			fill={color}
		/>
	</Svg>
);

const ToeicIntermediateIcon = ({
	size = 24,
	color = "black",
}: CustomLevelIconProps) => (
	<Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
		<Path
			d="M11 21V13.025C9.93333 13.025 8.90833 12.8208 7.925 12.4125C6.94167 12.0042 6.075 11.425 5.325 10.675C4.575 9.925 4 9.05833 3.6 8.075C3.2 7.09167 3 6.06667 3 5V3H5C6.05 3 7.06667 3.20417 8.05 3.6125C9.03333 4.02083 9.9 4.6 10.65 5.35C11.1667 5.86667 11.5958 6.43333 11.9375 7.05C12.2792 7.66667 12.5417 8.325 12.725 9.025C12.8083 8.90833 12.9 8.79583 13 8.6875C13.1 8.57917 13.2083 8.46667 13.325 8.35C14.075 7.6 14.9417 7.02083 15.925 6.6125C16.9083 6.20417 17.9333 6 19 6H21V8C21 9.06667 20.7958 10.0917 20.3875 11.075C19.9792 12.0583 19.4 12.925 18.65 13.675C17.9 14.425 17.0375 15 16.0625 15.4C15.0875 15.8 14.0667 16 13 16V21H11ZM11 11C11 10.2 10.8458 9.4375 10.5375 8.7125C10.2292 7.9875 9.79167 7.34167 9.225 6.775C8.65833 6.20833 8.0125 5.77083 7.2875 5.4625C6.5625 5.15417 5.8 5 5 5C5 5.8 5.15 6.56667 5.45 7.3C5.75 8.03333 6.18333 8.68333 6.75 9.25C7.31667 9.81667 7.96667 10.25 8.7 10.55C9.43333 10.85 10.2 11 11 11ZM13 14C13.8 14 14.5625 13.85 15.2875 13.55C16.0125 13.25 16.6583 12.8167 17.225 12.25C17.7917 11.6833 18.2292 11.0333 18.5375 10.3C18.8458 9.56667 19 8.8 19 8C18.2 8 17.4333 8.15417 16.7 8.4625C15.9667 8.77083 15.3167 9.20833 14.75 9.775C14.1833 10.3417 13.75 10.9875 13.45 11.7125C13.15 12.4375 13 13.2 13 14Z"
			fill={color}
		/>
	</Svg>
);

const ToeicAdvancedIcon = ({
	size = 24,
	color = "black",
}: CustomLevelIconProps) => (
	<Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
		<Path
			d="M13.95 22H10.05V18H3L7 12H5L12 2L19 12H17L21 18H13.95V22ZM6.75 16H17.25L13.25 10H15.15L12 5.5L8.85 10H10.75L6.75 16Z"
			fill={color}
		/>
	</Svg>
);

export const customLevelIcons: Record<
	CustomLevelIconName,
	ComponentType<CustomLevelIconProps>
> = {
	"toeic-basic": ToeicBasicIcon,
	"toeic-intermediate": ToeicIntermediateIcon,
	"toeic-advanced": ToeicAdvancedIcon,
};
